import "./CheckEligibility.module.css";
import Header from "@/reusable_sections/Header";
import HeroWithLeadForm from "./sections/HeroWithLeadForm";
import AgentProfiles from "./sections/AgentProfiles";
import CommunitiesShowcase from "./sections/CommunitiesShowcase";
import LifestyleBenefits from "./sections/LifestyleBenefits";
import ValuePropositionBar from "./sections/ValuePropositionBar";
import FooterContact from "./sections/FooterContact";
import Footer from "@/reusable_sections/Footer";
export default function CheckEligibilityPage() {
  return <div>
      <HeroWithLeadForm />
      <AgentProfiles />
      <CommunitiesShowcase />
      <LifestyleBenefits />
      <ValuePropositionBar />
      <FooterContact />
    </div>;
}